export default __webpack_public_path__ + "static/supp-app-a0a9c80f151c12fa1ef82c582568fc63.jpg";